import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";

interface ImageItem {
	image: string;
	title?: string;
}

interface ImageProps {
	images: ImageItem | ImageItem[];
	index?: number;
	close: () => void;
}

export default function Image(props: ImageProps) {
	const photos = Array.isArray(props.images) ? props.images : [props.images];
	const slides = photos.map(({ image, title }) => ({ src: image, title }));

	return (
		<Lightbox
			className="lightbox-container"
			index={props.index}
			open
			close={props.close}
			slides={slides}
			plugins={[Zoom, Thumbnails, Captions]}
			zoom={{
				maxZoomPixelRatio: 10,
				scrollToZoom: true,
			}}
			thumbnails={{
				position: "bottom",
			}}
			carousel={{ finite: true }}
			render={{
				buttonPrev: slides.length <= 1 ? () => null : undefined,
				buttonNext: slides.length <= 1 ? () => null : undefined,
			}}
		/>
	);
}
